import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // Scoped to this element rather than a global selector, so it cannot collide with
    // the galleries on the public pages.
    this.gallery = new Swiper(this.element.querySelector('.admin-configurator-container'), {
      loop: false
    });
  }

  disconnect() {
    if (this.gallery) {
      this.gallery.destroy();
    }
  }

  galleryPrev() {
    if (this.gallery.isBeginning) {
      this.gallery.slideTo(this.gallery.slides.length - 1);
    } else {
      this.gallery.slidePrev();
    }
  }

  galleryNext() {
    if (this.gallery.isEnd) {
      this.gallery.slideTo(0);
    } else {
      this.gallery.slideNext();
    }
  }

}
